module.exports = __webpack_public_path__ + "static/img/service-qrCode.740da8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/service-qrCode.png
// module id = IOpd
// module chunks = 0